import { Moment } from 'moment';
import * as moment from 'moment';

import { MetaData } from 'src/app/platform/models/utils';
export class User {
    public id: number;
    public token: string;
    public client: number;
    public username: string;
    public firstname: string;
    public lastname: string;
    public dni: string;
    public phone: string;
    public phones: Array<PhoneData>;
    public email: string;
    public emails: Array<string>;
    public status: string;
    public accounts: Array<AccountData>;
    public addressName: string;
    public addressBilling: AddressData;
    public addressConection: AddressData;
    public addressConectionUpdated: boolean;
    public debit: UserDebit;
    public balance: UserBalance;

    public responseData: any;

    public subsidiary: MetaData;
    public segment: MetaData;
    public zone: MetaData;
    public saldo: number;
    public debtExpired: number;
    public invoicesUnpaid: number;
    public invoicesUnpaidExpired: number;
    public flowdatStatus: string;
    public services: string;
    public unsuscribeAccount: boolean;
    public unsuscribeServices: boolean;
    public paymentsAllow: boolean;
    public rol: string;
    public messages: Array<AccountMessage> = [];

    constructor() {
        this.id = 0;
        this.token = '';
        this.client = 0;
        this.username = '';
        this.firstname = '';
        this.lastname = '';
        this.dni = '';
        this.phone = '';
        this.phones = [];
        this.email = '';
        this.emails = [];
        this.status = '';
        this.accounts = [];
        this.addressName = '';
        this.addressBilling = new AddressData();
        this.addressConection = new AddressData();
        this.addressConectionUpdated = false;
        this.debit = new UserDebit();
        this.balance = new UserBalance();

        this.responseData = [];

        this.subsidiary = new MetaData();
        this.segment = new MetaData();
        this.zone = new MetaData();
        this.saldo = 0;
        this.debtExpired = 0;
        this.invoicesUnpaid = 0;
        this.invoicesUnpaidExpired = 0;
        this.flowdatStatus = '';
        this.services = '';
        this.unsuscribeAccount = false;
        this.unsuscribeServices = false;
        this.paymentsAllow = true;
    }

    get account(): AccountData{
        return this.accounts.find(account => account.number === this.client) ?? new AccountData();
    }
    /**
     * Returns true if the given user is valid.
     */
    get isAdmin(): boolean {
        return this.rol === 'admin';
    }
    
    /**
     * Returns true if the given user is valid.
     */
    isValid(): boolean {
        return this.id !== 0;
    }

    /**
     * Returns true if the given user is valid.
     */
    isReady(): boolean {
        if (this.client > 0) {
            return true;
        }

        return false;
    }

    /**
     * Returns true if the given user is valid.
     */
    isPaymentStatus(): boolean {
        return this.paymentsAllow;

        if (this.status === 'Desconectado' || this.status === 'BajaMoroso' || this.status === 'BajaPendiente') {
            return false;
        }

        return true;
    }

    /**
     * Set user data
     */
    configData(parameters: any): void {
        for (const [key, value] of Object.entries(parameters)) {
            if (typeof Object.prototype.hasOwnProperty.call(parameters, key) !== 'undefined') {
                (this as any)[key] = value;
            }
        }
console.log('configData', this);
        this.addressName =
            this.addressConection.street.name + ' ' +
            this.addressConection.number +
            ((this.addressConection.apartment !== '') ? ' ' + this.addressConection.apartment : '') + ', ' +
            this.addressConection.city.name + ', ' +
            this.addressConection.city.state.name;
    }

    /**
     * Parse accounts data
     */
    configAccounts(accounts: Array<object>): Array<object>{
        const accountSetup: Array<AccountData> = [];

        accounts.forEach((account: any): void => {
            accountSetup.push(new AccountData(account));
        });

        return accountSetup;
    }

    firstnameUnique(position?: number): string {
        const count = this.firstname.indexOf(' ');

        return (count > 0) ? this.firstname.substr((typeof position === 'undefined') ? 0 : position, count) : this.firstname;
    }

    debitIsSet(): boolean {
        return this.debit.status;
    }

    debitGetType(): string {
        return this.debit.type;
    }
}
export class AccountData {
    public name = '';
    public number = 0;
    public status = '';
    public messages: Array<AccountMessage> = [];

    constructor(parameters?: any) {
        this.number = parameters.clienteId ?? 0;
        this.status = parameters.estado ?? '';
        this.name = parameters.nombre ?? '';

        if(typeof parameters.mensajes !== 'undefined' && parameters.mensajes !== null && parameters.mensajes.length > 0){
            parameters.mensajes.forEach((message: any) => {
                this.messages.push(new AccountMessage(message));
            });
        }
    }
}

export class AccountMessage {
    public id = 0;
    public text = '';
    public level = '';
    public dateStart: Date = moment().toDate();
    public dateEnd: Date | null = moment().toDate();

    constructor(parameters: any) {
        this.id = parameters.id ?? 0;
        this.text = parameters.mensaje ?? '';
        this.level = parameters.nivel ? String(parameters.nivel).toLowerCase() : '';
        this.dateStart = moment(parameters.fechaDesde ?? '').toDate();
        this.dateEnd = parameters.fechaHasta ? moment(parameters.fechaHasta).toDate() : null;
    }

    get icon(): string {
       const icons: any = {
        info: 'info',
        warn: 'warning',
        error: 'error',
        fatal: 'cancel',
       }
        
       return icons[this.level];
    }
   
        /*get hasShow(): boolean {
        const now = new Date();
        const invalidDate = new Date("0001-01-01T00:00:00.000Z");

        return true;
        //return this.dateStart <= now && (!this.dateEnd || this.dateEnd.getTime() === invalidDate.getTime() || this.dateEnd >= now);
    }*/
}

export class UserDebit {
    public status: boolean;
    public type: string;

    constructor(type?: string) {
        this.status = false;
        this.type = this.getType((typeof type !== 'undefined') ? type : '');

        if (this.type !== '') {
            this.status = true;
        }
    }

    configData(parameters: any): UserDebit {
        this.status = parameters.debito;
        this.type = this.getType(parameters.tipoDebito);

        return this;
    }

    getType(type: string): string {
        if (type === 'CBU' || type === 'cbu') {
            return 'cbu';
        } else if (type === 'Tarjeta' || type === 'credit') {
            return 'credit';
        } else {
            return '';
        }
    }
}

export class UserBalance {
    public total: number;
    public status: boolean;

    constructor() {
        this.total = 0;
        this.status = false;
    }

    configData(parameters: any): UserBalance{
        this.total = (parameters.saldo).toFixed(2);
        this.status = this.getStatus(parameters.saldo);

        return this;
    }

    getStatus(total: number): boolean{
        if (total <= 0) {
            return true;
        }

        return false;
    }
}

export class PhoneData {
    public number: number;
    public type: string;

    constructor() {
        this.number = 0;
        this.type = '';
    }

    configData(parameters: any): PhoneData{
        this.number = parameters.ani;
        this.type = parameters.tipo;

        return this;
    }

    processData(data: Array<any>): Array<PhoneData> {
        const phoneData: Array<PhoneData> = [];

        data.forEach((value: any, index: number) => {
            phoneData.push(new PhoneData().configData(value));
        });

        return phoneData;
    }
}

export class AddressData {
    public city: CityData;
    public street: MetaData;
    public number: string;
    public apartment: string;
    public block: BlockData;

    constructor() {
        this.city = new CityData();
        this.street = new MetaData();
        this.number = '';
        this.apartment = '';
        this.block = new BlockData();
    }

    configData(parameters: any): AddressData{
        this.city = new CityData().configData(parameters.localidad);
        this.street = new MetaData().configData(parameters.calle);
        this.number = parameters.altura;
        this.apartment = parameters.apartamento;
        this.block = new BlockData().configData(parameters.manzana);

        return this;
    }
}

export class CityData {
    public id: number;
    public name: string;
    public state: MetaData;
    public department: MetaData;

    constructor() {
        this.id = 0;
        this.name = '';
        this.state = new MetaData();
        this.department = new MetaData();
    }

    configData(parameters: any): CityData{
        this.id = parameters.id;
        this.name = parameters.nombre;
        this.state = new MetaData().configData(parameters.provincia);
        this.department = new MetaData().configData(parameters.departamento);

        return this;
    }
}

export class BlockData {
    public id: number;
    public zipCode: string;
    public street: MetaData;
    public start: number;
    public end: number;
    public parity: string;

    constructor() {
        this.id = 0;
        this.zipCode = '';
        this.street = new MetaData();
        this.start = 0;
        this.end = 0;
        this.parity = '';
    }

    configData(parameters: any): BlockData{
        this.id = parameters.id;
        this.zipCode = parameters.cpa;
        this.street = new MetaData().configData(parameters.calle);
        this.start = parameters.inicio;
        this.end = parameters.fin;
        this.parity = parameters.paridad;

        return this;
    }
}

export function accountStatus(status: string): string {
    const statusTypes: any = {
        Conectado: 'Conectado',
        Desconectado: 'Desconectado',
        BajaMoroso: 'Baja por mora',
        BajaPendiente: 'Baja pendiente',
        BajaSolicitada: 'Baja solicitada',
    };

    if (typeof statusTypes[status] !== 'undefined') {
        return statusTypes[status];
    }

    return status;
}
